import React, {
    createContext,
    useState,
    useEffect,
    useContext,
    useMemo,
    useCallback,
} from 'react'
import { CurrentProcessContext } from './CurrentProcessContext'
import filterByAttributes from '../../utils/filterByAttributes'

const FilterContext = createContext(null)

const FilterContextProvider = ({ children }) => {
    const [filters, setFilters] = useState({
        ActionGroup: null,
        StateName: null,
        Status: null,
    })
    const [criteria, setCriteria] = useState({})
    const { externalDataItems } = useContext(CurrentProcessContext)

    const [filteredData, setFilteredData] = useState([])
    const [barFilter, setBarFilter] = useState([])
    const [attributeData, setAttributeData] = useState([])

    const { Status, ...noStatusFilters } = filters

    const statusCount = useMemo(() => {
        return externalDataItems.filter((item) =>
            Object.keys(noStatusFilters).every((filter) => {
                return (
                    filters[filter] === null || filters[filter] === item[filter]
                )
            })
        )
    }, [noStatusFilters])

    const calcFilters = useCallback(() => {
        if (filters.Status !== null) {
            setBarFilter(
                statusCount.filter(
                    (item) =>
                        filters.Status === null ||
                        filters.Status === item.Status
                )
            )
        } else {
            setBarFilter(
                externalDataItems.filter((item) =>
                    Object.keys({ ...filters, Status: null }).every(
                        (filter) =>
                            filters[filter] === null ||
                            filters[filter] === item[filter]
                    )
                )
            )
        }
    }, [externalDataItems, filters])

    const calcAttributes = useCallback(() => {

        // const attData = Object.values(filters).every((x) => x === null) || !barFilter.length ? externalDataItems : barFilter
        if (Object.keys(criteria).length && externalDataItems.length) {
            setAttributeData(filterByAttributes(externalDataItems, criteria))
        } else {
            setAttributeData([])
        }
    }, [criteria, externalDataItems])

    useEffect(() => {
        calcFilters()
        calcAttributes()
    }, [filters, externalDataItems, criteria])

    useEffect(() => {
        if (!barFilter.length && !filteredData.length) {
            setFilteredData(externalDataItems)
        }
        if (barFilter.length && !attributeData.length) {
            setFilteredData(barFilter)
        }
        if (attributeData.length) {
            setFilteredData(barFilter.filter(element => attributeData.includes(element)))
        }
    }, [attributeData, barFilter, externalDataItems])

    return (
        <FilterContext.Provider
            value={{
                filteredData,
                setFilteredData,
                statusCount,
                criteria,
                setCriteria,
                filters,
                setFilters,
            }}
        >
            {children}
        </FilterContext.Provider>
    )
}

export { FilterContext }
export default FilterContextProvider
